<template>
  <div>
    <Navbar v-if="this.$route.name == 'invoicereport'"/>
    <Breadcrumb v-if="this.$route.name == 'invoicereport'" />
    <div v-show="invoice_id==0">
      <b-row class="col-12 px-0">
        <b-input-group small class="ml-0 mt-3 mb-3">
          <b-form-select
            placeholder="Bulk action"
            v-model="bulkaction"
            class="ml-4 mr-2 rounded gdq-w-110px"
          >
            <option value="0" class="text-muted">Bulk action</option>
            <option v-show="selectcount != 0" value="2">
              Export selected to Excel
            </option>
            <option v-show="invoices.length > 0" value="3">
              Export ALL in list to Excel
            </option>
          </b-form-select>
          <b-form-select
            @change="invoices_filterget"
            v-model="filtersurveytype"
            class="rounded mr-2 gdq-w-100px"
            placeholder="Type"
            :options="surveytypes"
          >
          </b-form-select>
          <b-form-select
            @change="invoices_filterget"
            v-model="filterpaymentstatus"
            class="mr-2 rounded"
            placeholder="All invoices"
          >
            <option value="0">All invoices</option>
            <option value="1">Unpaid invoices</option>
            <option value="2">Paid invoices</option>
          </b-form-select>
          <b-form-select
            @change="invoices_filterget"
            v-model="filterpaymentmethod"
            class="rounded"
            placeholder="Payment method"
            :options="paymentmethods"
          >
          </b-form-select>
          <b-form-select
            @change="invoices_filterget"
            v-model="filtercompany"
            class="rounded ml-2"
            placeholder="All companies"
            :options="companies"
          >
          </b-form-select>
          <b-form-select
            @change="invoices_filterget"
            v-model="filterpartner"
            class="rounded ml-2"
            placeholder="All partners"
            :options="partners"
          >
          </b-form-select>
          <span class="pt-2 mr-1 ml-1">Inv. date</span>
          <datetime
            type="date"
            size="9"
            class="mr-1"
            input-class="form-control"
            format="yyyy-LL-dd"
            :phrases="{ ok: 'OK', cancel: 'Cancel' }"
            v-model="start_date"
            v-on:close="invoices_filterget"
            value-zone="Europe/Stockholm"
            zone="Europe/Stockholm"
          >
          </datetime>
          <span class="pt-2 mr-1">-</span>
          <datetime
            type="date"
            size="9"
            input-class="form-control"
            format="yyyy-LL-dd"
            :phrases="{ ok: 'OK', cancel: 'Cancel' }"
            v-model="end_date"
            v-on:input="invoices_filterget"
            value-zone="Europe/Stockholm"
            zone="Europe/Stockholm"
          >
          </datetime>
          <span class="pt-2 mr-1 ml-2">per page</span>
          <b-form-select
            @change="invoices_filterget"
            v-model="perPage"
            class="rounded ml-2 gdq-w-70px"
            :options="perpageoptions"
          >
          </b-form-select>
        </b-input-group>
        <b-input-group class="col-2">

        </b-input-group>
      </b-row>
      <b-row
        v-show="bulkaction == 2 || bulkaction == 3"
        small
        class="col ml-0 mt-0 mb-3"
      >
        <b-form-input
          v-model="exportexcelfilename"
          placeholder="Enter Excel file name"
          type="text"
          class="col-3"
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text
          slot="append"
          :class="exportexcelfilename == '' ? 'bg-danger' : 'bg-success'"
        >
          <b-btn variant="link" size="sm" class="p-0 i">
            <span
              @click.prevent="exportexcel_save"
              style="color: black"
              v-show="exportexcelfilename != ''"
              class="icon-checkmark"
            ></span>
            <span
              @click.prevent="exportexcel_cancel"
              style="color: black"
              v-show="exportexcelfilename == ''"
              class="icon-cross danger"
            ></span>
          </b-btn>
        </b-input-group-text>
      </b-row>
      <b-row class="col-12">
        <b-table
          id="invoices"
          :class="'invoicesTable'"
          hover
          fixed
          :items="invoices"
          :fields="fields"
          :busy="loading"
          :sort-by="orderby"
          :sort-desc="orderdesc"
          @sort-changed="invoices_sort"
          :no-local-sorting="true"
          @row-clicked="invoice_edit"
          ref="invoices"
        >
          <template v-slot:head(select)="data">
            <b-form-checkbox
              @click.native.stop
              v-model="selected"
              value="1"
              unchecked-value="0"    
            >
              <span class="text-muted" v-if="selectcount > 0"
                >({{ selectcount }})</span
              >
            </b-form-checkbox>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner variant="primary" class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(select)="data">
            <div class="py-1">
              <b-form-checkbox
                v-model="data.item.selected"
                @change="countselected"
                value="1"
                unchecked-value="0"                
              >
              </b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(invoice_number)="data">
            {{data.item.invoice_number}}<br>
            <span title="Invoice Reference">{{data.item.invoice_reference!=''?'('+data.item.invoice_reference+')':''}}</span>
          </template>
          <template v-slot:cell(invoice_paid_amount)="data">
            {{data.item.invoice_paid_amount}}<br>
            <span title="Payment method">({{data.item.paymentmethod_name}})</span>
          </template>
          <template v-slot:cell(consultant_name)="data">
            <span :class="`${anon ? 'g-anon' : '' }`">
              {{data.item.consultant_name}}<br>
              {{data.item.company_name}}<br>
              {{data.item.partner_name}}
            </span>
          </template>
          <template v-slot:cell(email)="data">
            <span :class="`${anon ? 'g-anon' : '' }`">
              {{data.item.email}}
            </span>
          </template>      
          <template v-slot:cell(invoice_amount)="data">
            {{data.item.invoice_amount_inc_vat}}<br>
            (VAT: {{data.item.invoice_vat_amount}})
          </template>
          <template v-slot:cell(survey_name)="data">
            {{data.item.survey_name}}<br>
            <span v-if="data.item.number_members > 0">({{data.item.number_members}} resp.)</span>
          </template>
        </b-table>
      </b-row>
      <b-row class="col-12 justify-content-center">
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="invoices"
          @input="invoices_get"
        >
        </b-pagination>
      </b-row>
    </div>
    <div v-show="invoice_id!=0">
      <Invoice 
        :invoiceId="invoice_id"
        v-on:invoiceClose="invoicelist_show"
        v-on:invoiceChange="invoices_get"
      />
    </div>
  </div>
</template>
<script>
import { Datetime } from "vue-datetime";
import Invoice from "./Invoice";
import Navbar from "./Navbar";
import Breadcrumb from './Breadcrumb.vue'

const fields = [
  { key: "select", label: "", sortable: false, thClass: "gdq-w-50px", tdClass: "mx-0 align-top gdq-w-50px" },
  { key: "invoice_number", label: "Number", sortable: true },
//  { key: "invoice_reference", label: "Ref.", sortable: true },
  { key: "invoice_date", label: "Date", sortable: true },
  { key: "invoice_amount", label: "Amount", sortable: true },
//  { key: "invoice_vat_amount", label: "VAT", sortable: false },
//  { key: "invoice_amount_inc_vat", label: "Inc VAT", sortable: false },
  { key: "invoice_paid_amount", label: "Paid", sortable: true },
//  { key: "paymentmethod_name", label: "Pay by", sortable: true },
  { key: "consultant_name", label: "Consultant", sortable: true, tdClass: "`py-0 ${anon ? 'g-anon' : '' }`" },
//  { key: "company_name", label: "Comp.", sortable: true },
//  { key: "partner_name", label: "Partner", sortable: true },
  { key: "email", label: "E-mail", sortable: true },
  { key: "survey_name", label: "Survey", sortable: true },
//  { key: "number_members", label: "No.", sortable: true },
];

const perpageoptions = [
  { text: '10', value: 10 },
  { text: '25', value: 25 },
  { text: '100', value: 100 },
  { text: '250', value: 250 },
]

export default {
  components: {
    Datetime,
    Invoice,
    Navbar,
    Breadcrumb,
  },
  name: "InvoiceReport",
  created() {
    this.paymentmethods_get();
    this.companies_get();
    this.partners_get();
    this.surveytypes_get();
    this.dates_setdefault();
  },
  mounted() {
    this.invoices_get();
  },
  data: function () {
    return {
      exportexcelfilename: "",
      filterpaymentstatus: 0,
      start_date: null,
      end_date: null,
      invoices: [],
      allinvoices: [],
      orderby: "invoice_number",
      order: "ASC",
      orderdesc: false,
      perPage: 10,
      perpageoptions: perpageoptions,
      rows: 0,
      currentPage: 1,
      fields: fields,
      loading: null,
      selectcount: 0,
      selected: 0,
      filterpaymentmethod: 0,
      paymentmethods: [],
      filtercompany: 0,
      companies: [],
      filterpartner: 0,
      partners: [],
      bulkaction: 0,
      invoice_id: 0,
      filtersurveytype: 0,
      surveytypes: [],
    };
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
  },
  watch: {
    selected: function(val) {
      this.selectall(val);
    }
  },
  methods: {
    invoicelist_show() {
      this.invoice_id = 0;
    },
    invoice_edit(item) {
      this.invoice_id=item.id;
    },
    async exportexcel_save() {
      if (this.bulkaction == 3) {
        await this.invoices_getallfiltered().then((invoices) => {
          this.$store
            .dispatch("invoices_exportexcel", { ids: invoices })
            .then((resp) => {
              var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              var filename = this.exportexcelfilename;
              fileLink.setAttribute("download", filename + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.bulkaction = 0;
            });
        });
      } else {
        var ids = [];
        for (var i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].selected == 1) {
            ids.push(this.invoices[i].id);
          }
        }
        var data = {
          ids: ids,
        };
        this.$store.dispatch("invoices_exportexcel", data).then((resp) => {
          var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          var filename = this.exportexcelfilename;
          fileLink.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.bulkaction = 0;
        });
      }
    },
    exportexcel_cancel() {
      this.bulkaction = 0;
      this.exportexcelfilename = "";
    },
    selectall(selected) {
      this.$nextTick(() => {      
        const setselectto = selected;
        for (var i=0;i<this.invoices.length; i++) {
            this.invoices[i].selected = setselectto;
        }
        this.countselected();
      });
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].selected == 1) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      });
    },
    surveytypes_get() {
      this.$store
        .dispatch("surveytypes_fetch")
        .then((resp) => {
          this.surveytypes = [];
          this.surveytypes.push({
            value: 0,
            text: "All types",
          });
          var surveytypes = resp.data.result;
          for (var i = 0; i < surveytypes.length; i++) {
            this.surveytypes.push({
              value: surveytypes[i].id,
              text: surveytypes[i].surveytype_name,
            });
          }
          this.surveytypes.push({
            value: 99,
            text: 'Aggregated',
          })
        });      

    },
    companies_get() {
      this.$store
        .dispatch("companies_fetch", {
          filter: "",
          start: 1,
          limit: 999999,
          orderby: "company_name",
          order: "ASC",
        })
        .then((resp) => {
          this.companies = [];
          this.companies.push({
            value: 0,
            text: "All companies",
          });
          var companies = resp.data.result;
          for (var i = 0; i < companies.length; i++) {
            this.companies.push({
              value: companies[i].id,
              text: companies[i].company_name,
            });
          }
        });
    },
    partners_get() {
      this.$store
        .dispatch("partners_fetch", {
          filter: "",
          start: 1,
          limit: 999999,
          orderby: "partner_name",
          order: "ASC",
        })
        .then((resp) => {
          this.partners = [];
          this.partners.push({
            value: 0,
            text: "All partners",
          });
          var partners = resp.data.result;
          for (var i = 0; i < partners.length; i++) {
            this.partners.push({
              value: partners[i].id,
              text: partners[i].partner_name,
            });
          }
        });
    },
    paymentmethods_get() {
      this.$store.dispatch("paymentmethods_fetch", {}).then((resp) => {
        this.paymentmethods = [];
        this.paymentmethods.push({
          value: 0,
          text: "All pay methods",
        });
        var paymentmethods = resp.data.result;
        for (var i = 0; i < paymentmethods.length; i++) {
          this.paymentmethods.push({
            value: paymentmethods[i].id,
            text: paymentmethods[i].paymentmethod_name,
          });
        }
      });
    },
    dates_setdefault() {
      var date = new Date();
      var start_date = new Date(date.getFullYear(), date.getMonth(), 1);
      this.start_date = start_date.toISOString();
      var end_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.end_date = end_date.toISOString();
    },
    invoices_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.invoices_filterget();
    },
    invoices_filterget() {
      this.currentPage = 1;
      this.invoices_get();
    },
    invoices_get() {
      this.loading = true;
      var filter = {};
      if (this.filterpaymentstatus == 1) {
        filter["invoice_paid_amount"] = {
          operator: " < ",
          value: "g_consultantinvoices.invoice_amount",
        };
      }
      if (this.filterpaymentstatus == 2) {
        filter["invoice_paid_amount"] = {
          operator: " >= ",
          value: "g_consultantinvoices.invoice_amount",
        };
      }
      var start_date = this.format_date(this.start_date);
      var end_date = this.format_date(this.end_date);
      filter["invoice_date"] = {
        operator: " BETWEEN ",
        value: "'" + start_date + "' AND '" + end_date + "'",
      };
      if (this.filterpaymentmethod != 0) {
        filter["invoice_payment_method_id"] = {
          operator: " = ",
          value: this.filterpaymentmethod,
        };
      }
      if (this.filtersurveytype == 99) {
        filter["invoice_type"] = {
          operator: " = ",
          value: "'A'",
        }
      } else {
        filter["invoice_type"] = {
          operator: " <> ",
          value: "'XYZ'",
        }
      }
      this.$store
        .dispatch("invoices_fetch", {
          start: this.currentPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: this.orderdesc == false ? "ASC" : "DESC",
          filter: filter,
          company_id: this.filtercompany,
          partner_id: this.filterpartner,
          surveytype_id: this.filtersurveytype,
        })
        .then((resp) => {
          this.invoices = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var result = resp.data.result[i];
            result.selected = 0;
            this.invoices.push(result);
          }
          this.rows = resp.data.total;
          this.loading = false;
        });
    },
    async invoices_getallfiltered() {
      return new Promise((resolve) => {
        this.loading = true;
        var filter = {};
        if (this.filterpaymentstatus == 1) {
          filter["invoice_paid_amount"] = {
            operator: " < ",
            value: "g_consultantinvoices.invoice_amount",
          };
        }
        if (this.filterpaymentstatus == 2) {
          filter["invoice_paid_amount"] = {
            operator: " >= ",
            value: "g_consultantinvoices.invoice_amount",
          };
        }
        var start_date = this.format_date(this.start_date);
        var end_date = this.format_date(this.end_date);
        filter["invoice_date"] = {
          operator: " BETWEEN ",
          value: "'" + start_date + "' AND '" + end_date + "'",
        };
        if (this.filterpaymentmethod != 0) {
          filter["invoice_payment_method_id"] = {
            operator: " = ",
            value: this.filterpaymentmethod,
          };
        }
        if (this.filtersurveytype == 99) {
          filter["invoice_type"] = {
            operator: " = ",
            value: "'A'",
          }
        } else {
          filter["invoice_type"] = {
            operator: " <> ",
            value: "'XYZ'",
          }
        }
        this.$store
          .dispatch("invoices_fetch", {
            start: 1,
            limit: 100000,
            orderby: this.orderby,
            order: this.orderdesc == false ? "ASC" : "DESC",
            filter: filter,
            company_id: this.filtercompany,
            partner_id: this.filterpartner,
          })
          .then((resp) => {
            this.allinvoices = [];
            for (var i = 0; i < resp.data.result.length; i++) {
              var result = resp.data.result[i];
              this.allinvoices.push(result.id);
            }
            this.loading = false;
            //return this.allinvoices;
            resolve(this.allinvoices);
          });
      });
    },
    //=================
    // HELPER FUNCTIONS
    //=================
    format_date(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (isNaN(year)) {
        return "";
      }
      if (Number.isNaN(month)) {
        return "";
      }
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  },
};
</script>
<style>
.checkbox-col {
  width: 28px !important;
}
.invoicesTable {
  font-size: 0.9rem !important;
}
</style>
